(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  /* Build a seamless marquee from one authored group:
       1. Clone the group until a single "unit" is at least as wide as the bar,
          so there is never a visible gap before it repeats.
       2. Place two units in the track and animate a -50% translate, which lands
          exactly one unit over — a seamless loop.
       3. Derive duration from unit width so px/second stays constant no matter
          how much text there is.
     Skipped entirely under reduced-motion; the static first group remains. */
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.track = this.querySelector('[data-marquee-track]');
      this.group = this.querySelector('[data-marquee-group]');
      if (!this.track || !this.group) return;

      // Fonts can shift widths after layout; wait for them before measuring.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.build());
      } else {
        this.build();
      }

      // Rebuild on resize so the fill stays correct across breakpoints.
      this._onResize = this.debounce(() => this.build(), 200);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    build() {
      // Reset to a single authored group.
      this.track.querySelectorAll('[data-marquee-clone]').forEach((n) => n.remove());
      const original = this.group;

      const viewport = this.offsetWidth;
      let unitWidth = original.offsetWidth;
      if (unitWidth === 0 || viewport === 0) return;

      // Repeat the group inside a single unit until it spans the viewport.
      const unit = document.createElement('div');
      unit.className = 'announcement__group';
      unit.setAttribute('data-marquee-unit', '');
      const copies = Math.max(1, Math.ceil(viewport / unitWidth));
      for (let i = 0; i < copies; i++) unit.appendChild(original.cloneNode(true));

      // Track = the built unit + one aria-hidden duplicate.
      const dup = unit.cloneNode(true);
      dup.setAttribute('aria-hidden', 'true');
      dup.setAttribute('data-marquee-clone', '');
      unit.setAttribute('data-marquee-clone', '');

      original.style.display = 'none';
      this.track.appendChild(unit);
      this.track.appendChild(dup);

      const distance = unit.offsetWidth;
      const speed = parseFloat(this.style.getPropertyValue('--marquee-speed')) || 40; // px/sec
      this.style.setProperty('--marquee-distance', distance + 'px');
      this.style.setProperty('--marquee-duration', (distance / speed).toFixed(2) + 's');
      this.classList.add('is-ready');
    }

    debounce(fn, ms) {
      let t;
      return () => { clearTimeout(t); t = setTimeout(fn, ms); };
    }
  }

  if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', AnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.overlay = this.querySelector("[data-cart-overlay]");
      this.panel = this.querySelector("[data-cart-panel]");
      this.rewards = this.querySelector("[data-cart-rewards]");
      this.lastFocused = null;

      try { this.i18n = JSON.parse(this.dataset.i18n || "{}"); } catch (e) { this.i18n = {}; }
      this.currency = this.dataset.currency || "USD";

      if (this.rewards) {
        try { this.milestones = JSON.parse(this.rewards.dataset.rewards || "[]"); } catch (e) { this.milestones = []; }
        this.maxThreshold = this.milestones.reduce((m, x) => Math.max(m, x.t), 0);
        this.tplRemaining = this.rewards.dataset.tplRemaining || "";
        this.tplComplete = this.rewards.dataset.tplComplete || "";
      }

      this.overlay.addEventListener("click", () => this.close());
      this.addEventListener("click", (e) => this.onClick(e));
      this.addEventListener("keydown", (e) => this.onKeydown(e));

      document.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-cart-open]");
        if (trigger) { e.preventDefault(); this.open(); }
      });

      document.addEventListener("submit", (e) => {
        const form = e.target;
        if (form.matches && form.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          this.addFromForm(form);
        }
      });

      this.updateCounts(Number(this.dataset.cartCountSource) || 0);
    }

    /* ---- helpers ---- */
    route(path) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
      return root + path;
    }
    sectionId() { return "cart-drawer"; }
    reduce() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
    money(cents) {
      try {
        return new Intl.NumberFormat(undefined, { style: "currency", currency: this.currency }).format(cents / 100);
      } catch (e) {
        return "$" + (cents / 100).toFixed(2);
      }
    }
    t(key) { return this.i18n[key] || ""; }

    /* ---- open / close / focus ---- */
    focusable() {
      return Array.from(this.panel.querySelectorAll('a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])'))
        .filter((el) => el.offsetParent !== null);
    }
    open() {
      this.lastFocused = document.activeElement;
      this.setAttribute("open", "");
      this.panel.removeAttribute("inert");
      document.body.style.overflow = "hidden";
      const close = this.querySelector("[data-cart-close]");
      if (close) close.focus();
    }
    close() {
      this.removeAttribute("open");
      this.panel.setAttribute("inert", "");
      document.body.style.overflow = "";
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
    }
    onKeydown(e) {
      if (!this.hasAttribute("open")) return;
      if (e.key === "Escape") { e.preventDefault(); this.close(); return; }
      if (e.key === "Enter" && e.target.matches("[data-discount-input]")) { e.preventDefault(); this.applyDiscount(); return; }
      if (e.key !== "Tab") return;
      const items = this.focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    onClick(e) {
      if (e.target.closest("[data-cart-close]")) { this.close(); return; }
      const qtyBtn = e.target.closest("[data-qty-change]");
      if (qtyBtn) { this.changeQty(qtyBtn); return; }
      const removeBtn = e.target.closest("[data-remove]");
      if (removeBtn) { this.removeItem(removeBtn); return; }
      const add = e.target.closest("[data-upsell-add]");
      if (add) { this.addUpsell(add); return; }
      if (e.target.closest("[data-upsell-next]")) { this.scrollUpsell(1); return; }
      if (e.target.closest("[data-upsell-prev]")) { this.scrollUpsell(-1); return; }
      if (e.target.closest("[data-discount-apply]")) { this.applyDiscount(); return; }
      if (e.target.closest("[data-discount-remove]")) { this.removeDiscount(); return; }
    }

    /* ---- add to cart from any product form ---- */
    async addFromForm(form) {
      const button = form.querySelector('[name="add"]');
      if (button) button.setAttribute("aria-busy", "true");
      const body = new FormData(form);
      body.append("sections", this.sectionId());
      body.append("sections_url", window.location.pathname);
      try {
        const res = await fetch(this.route("cart/add.js"), { method: "POST", headers: { Accept: "application/json" }, body });
        const data = await res.json();
        if (!res.ok) { this.announce(data.description || data.message || this.t("error")); return; }
        this.applySections(data.sections);
        this.open();
        this.announce(this.t("added"));
      } catch (err) {
        this.announce(this.t("error"));
      } finally {
        if (button) button.removeAttribute("aria-busy");
      }
    }

    /* ---- quantity (optimistic) ---- */
    changeQty(btn) {
      const row = btn.closest("[data-key]");
      const valueEl = row.querySelector("[data-qty-value]");
      const current = Number(valueEl.textContent) || 0;
      const next = Math.max(0, current + Number(btn.dataset.qtyChange));
      if (next === current) return;
      valueEl.textContent = next;
      row.classList.add("is-updating");
      row.querySelectorAll("[data-qty-change]").forEach((b) => { b.disabled = true; });
      this.clearItemError(row);
      this.changeCart({ id: row.dataset.key, quantity: next }, row, current);
    }
    removeItem(btn) {
      const row = btn.closest("[data-key]");
      row.classList.add("is-updating");
      this.changeCart({ id: row.dataset.key, quantity: 0 }, row);
    }
    async changeCart(payload, row, revertTo) {
      payload.sections = this.sectionId();
      payload.sections_url = window.location.pathname;
      try {
        const res = await fetch(this.route("cart/change.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok) {
          if (row && revertTo != null) { const v = row.querySelector("[data-qty-value]"); if (v) v.textContent = revertTo; }
          this.showItemError(row, data.description || data.message || this.t("error"));
          this.reenable(row);
          return;
        }
        this.applySections(data.sections);
        this.announce(this.t("updated"));
      } catch (err) {
        if (row && revertTo != null) { const v = row.querySelector("[data-qty-value]"); if (v) v.textContent = revertTo; }
        this.showItemError(row, this.t("error"));
        this.reenable(row);
      }
    }
    reenable(row) {
      if (!row) return;
      row.classList.remove("is-updating");
      row.querySelectorAll("[data-qty-change]").forEach((b) => { b.disabled = false; });
    }
    showItemError(row, msg) {
      if (!row) { this.announce(msg); return; }
      const el = row.querySelector("[data-item-error]");
      if (el) { el.textContent = msg; el.hidden = false; }
      this.announce(msg);
    }
    clearItemError(row) {
      const el = row && row.querySelector("[data-item-error]");
      if (el) { el.hidden = true; el.textContent = ""; }
    }

    /* ---- upsell ---- */
    async addUpsell(btn) {
      btn.setAttribute("aria-busy", "true");
      try {
        const res = await fetch(this.route("cart/add.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }], sections: this.sectionId(), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (!res.ok) { this.announce(data.description || this.t("error")); return; }
        this.applySections(data.sections);
        this.announce(this.t("added"));
      } catch (e) {
        this.announce(this.t("error"));
      } finally {
        btn.removeAttribute("aria-busy");
      }
    }
    scrollUpsell(dir) {
      const track = this.querySelector("[data-upsell-track]");
      if (!track) return;
      const card = track.querySelector(".cart-upsell__card");
      const step = (card ? card.offsetWidth + 14 : 150) * 2;
      track.scrollBy({ left: dir * step, behavior: this.reduce() ? "auto" : "smooth" });
    }

    /* ---- discount ---- */
    async applyDiscount() {
      const input = this.querySelector("[data-discount-input]");
      const btn = this.querySelector("[data-discount-apply]");
      if (!input) return;
      const code = input.value.trim();
      if (!code) return;
      this.setDiscountError("");
      if (btn) btn.setAttribute("aria-busy", "true");
      try {
        const res = await fetch(this.route("cart/update.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: code, sections: this.sectionId(), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        const applied = this.discountApplied(data, code);
        this.applySections(data.sections);
        if (applied) { const i = this.querySelector("[data-discount-input]"); if (i) i.value = ""; }
        else { this.setDiscountError(this.t("invalid")); }
      } catch (e) {
        this.setDiscountError(this.t("error"));
      } finally {
        const b = this.querySelector("[data-discount-apply]"); if (b) b.removeAttribute("aria-busy");
      }
    }
    async removeDiscount() {
      this.setLoading(true);
      try {
        const res = await fetch(this.route("cart/update.js"), {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: "", sections: this.sectionId(), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        this.applySections(data.sections);
      } catch (e) {
        this.announce(this.t("error"));
      } finally {
        this.setLoading(false);
      }
    }
    discountApplied(cart, code) {
      const codes = cart && cart.discount_codes;
      if (Array.isArray(codes)) {
        const match = codes.find((c) => (c.code || "").toLowerCase() === code.toLowerCase());
        if (match) return match.applicable !== false;
        return false;
      }
      return !!(cart && cart.total_discount > 0);
    }
    setDiscountError(msg) {
      const el = this.querySelector("[data-discount-error]");
      if (!el) return;
      if (msg) { el.textContent = msg; el.hidden = false; } else { el.textContent = ""; el.hidden = true; }
    }

    /* ---- re-render + persistent updates ---- */
    setLoading(state) { this.classList.toggle("is-loading", state); }

    applySections(sections) {
      if (!sections || !sections["cart-drawer"]) return;
      const doc = new DOMParser().parseFromString(sections["cart-drawer"], "text/html");

      const curTrack = this.querySelector("[data-upsell-track]");
      const upsellScroll = curTrack ? curTrack.scrollLeft : 0;

      const nextInner = doc.querySelector("[data-cart-inner]");
      const curInner = this.querySelector("[data-cart-inner]");
      if (nextInner && curInner) curInner.innerHTML = nextInner.innerHTML;

      const newTrack = this.querySelector("[data-upsell-track]");
      if (newTrack) newTrack.scrollLeft = upsellScroll;

      const root = doc.querySelector("cart-drawer");
      if (root) {
        const count = Number(root.dataset.cartCountSource) || 0;
        const totalCents = Number(root.dataset.cartTotal) || 0;
        const totalMoney = root.dataset.cartTotalMoney || "";
        if (count === 0) this.setAttribute("data-cart-empty", ""); else this.removeAttribute("data-cart-empty");
        this.updateCounts(count);
        this.updateRewards(totalCents);
        const checkoutTotal = this.querySelector("[data-checkout-total]");
        if (checkoutTotal && totalMoney) checkoutTotal.textContent = totalMoney;
      }
    }

    updateRewards(totalCents) {
      if (!this.rewards || !this.maxThreshold) return;
      const fill = this.rewards.querySelector("[data-rewards-fill]");
      if (fill) fill.style.setProperty("--progress", Math.min(100, Math.round((totalCents / this.maxThreshold) * 100)) + "%");
      this.rewards.querySelectorAll("[data-marker]").forEach((m) => {
        m.classList.toggle("is-reached", totalCents >= Number(m.dataset.threshold));
      });
      const msg = this.rewards.querySelector("[data-rewards-message]");
      if (!msg) return;
      const next = this.milestones.find((x) => totalCents < x.t);
      if (next) {
        msg.textContent = this.tplRemaining.replace("[[amount]]", this.money(next.t - totalCents)).replace("[[reward]]", next.label);
      } else {
        msg.textContent = this.tplComplete;
      }
    }

    updateCounts(count) {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    announce(message) {
      let region = document.getElementById("cart-live-region");
      if (!region) {
        region = document.createElement("div");
        region.id = "cart-live-region";
        region.setAttribute("aria-live", "polite");
        region.className = "visually-hidden";
        document.body.appendChild(region);
      }
      region.textContent = message;
    }
  }
  if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /* Move focus to the success/error notice after submit so the outcome is
     announced rather than silently rendered above the fold. */
  (function () {
    function focusNotice() {
      var notice = document.querySelector('[data-contact-success], [data-contact-error]');
      if (!notice) return;
      notice.focus();
      notice.scrollIntoView({ block: 'center' });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusNotice);
    } else {
      focusNotice();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileNav extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector("[data-menu-panel]");
      this.overlay = this.querySelector("[data-menu-overlay]");
      this.closeBtn = this.querySelector("[data-menu-close-btn]");
      this.openBtn = document.querySelector("[data-menu-open]");
      this.lastFocused = null;

      this.openBtn && this.openBtn.addEventListener("click", () => this.open());
      this.overlay && this.overlay.addEventListener("click", () => this.close());
      this.closeBtn && this.closeBtn.addEventListener("click", () => this.close());
      this.addEventListener("keydown", (e) => this.onKeydown(e));
    }

    focusable() {
      return Array.from(
        this.panel.querySelectorAll('a[href], button:not([disabled])')
      ).filter((el) => el.offsetParent !== null);
    }

    open() {
      this.lastFocused = document.activeElement;
      this.setAttribute("open", "");
      this.panel.removeAttribute("inert");
      this.openBtn && this.openBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      const items = this.focusable();
      (this.closeBtn || items[0]) && (this.closeBtn || items[0]).focus();
    }

    close() {
      this.removeAttribute("open");
      this.panel.setAttribute("inert", "");
      this.openBtn && this.openBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      this.lastFocused && this.lastFocused.focus();
    }

    onKeydown(e) {
      if (!this.hasAttribute("open")) return;
      if (e.key === "Escape") {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key !== "Tab") return;
      const items = this.focusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get("mobile-nav")) {
    customElements.define("mobile-nav", MobileNav);
  }

  class SearchOverlay extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector("[data-search-panel]");
      this.backdrop = this.querySelector("[data-search-overlay]");
      this.input = this.querySelector("[data-search-input]");
      this.results = this.querySelector("[data-search-results]");
      this.closeBtn = this.querySelector("[data-search-close]");
      this.lastFocused = null;
      this.timer = null;

      document.addEventListener("click", (e) => {
        const trigger = e.target.closest("[data-search-open]");
        if (trigger) { e.preventDefault(); this.open(); }
      });
      this.backdrop.addEventListener("click", () => this.close());
      this.closeBtn.addEventListener("click", () => this.close());
      this.addEventListener("keydown", (e) => { if (e.key === "Escape") this.close(); });
      this.input.addEventListener("input", () => this.onInput());
    }

    open() {
      this.lastFocused = document.activeElement;
      this.setAttribute("open", "");
      this.panel.removeAttribute("inert");
      document.body.style.overflow = "hidden";
      this.input.focus();
    }

    close() {
      this.removeAttribute("open");
      this.panel.setAttribute("inert", "");
      document.body.style.overflow = "";
      this.results.innerHTML = "";
      this.input.setAttribute("aria-expanded", "false");
      if (this.lastFocused) this.lastFocused.focus();
    }

    onInput() {
      clearTimeout(this.timer);
      const q = this.input.value.trim();
      if (q.length < 2) { this.results.innerHTML = ""; this.input.setAttribute("aria-expanded", "false"); return; }
      this.timer = setTimeout(() => this.fetchSuggestions(q), 220);
    }

    async fetchSuggestions(q) {
      const url = "/search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
      try {
        const res = await fetch(url);
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        this.render(products, q);
      } catch (err) {
        this.results.innerHTML = "";
      }
    }

    render(products, q) {
      if (!products.length) {
        this.results.innerHTML = "";
        this.input.setAttribute("aria-expanded", "false");
        return;
      }
      const items = products.map((p) => {
        const img = (p.featured_image && p.featured_image.url) || (p.image) || "";
        const media = img
          ? '<img class="predictive-item__media" src="' + img + '&width=120" alt="" loading="lazy" width="48" height="48">'
          : '<span class="predictive-item__media"></span>';
        return '<a class="predictive-item" role="option" href="' + p.url + '">' + media +
          '<span class="predictive-item__title">' + p.title + "</span></a>";
      }).join("");
      const viewAll = '<a class="search-overlay__view-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">' +
        (this.dataset.viewAllLabel || "View all results") + "</a>";
      this.results.innerHTML = items + viewAll;
      this.input.setAttribute("aria-expanded", "true");
    }
  }
  if (!customElements.get("search-overlay")) {
    customElements.define("search-overlay", SearchOverlay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-facet-form]");
      this.toggle = this.querySelector("[data-facet-toggle]");
      this.closeBtn = this.querySelector("[data-facet-close]");

      // Auto-submit on change (progressive enhancement).
      this.form.addEventListener("change", (e) => {
        if (e.target.matches("[data-facet-input]")) this.form.requestSubmit();
      });

      if (this.toggle) this.toggle.addEventListener("click", () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener("click", () => this.close());
      this.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.classList.contains("is-open")) this.close();
      });
    }
    open() {
      this.classList.add("is-open");
      if (this.toggle) this.toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      if (this.closeBtn) this.closeBtn.focus();
    }
    close() {
      this.classList.remove("is-open");
      if (this.toggle) { this.toggle.setAttribute("aria-expanded", "false"); this.toggle.focus(); }
      document.body.style.overflow = "";
    }
  }
  if (!customElements.get("facet-filters")) customElements.define("facet-filters", FacetFilters);

  /* Dual-handle price slider. Two overlaid range inputs drive the same params
     Shopify's price_range filter already expects, so filtering still works
     without JS via the form itself. */
  (function initPriceRange() {
    function setup(root) {
      var min = root.querySelector("[data-price-min]");
      var max = root.querySelector("[data-price-max]");
      var fill = root.querySelector("[data-price-fill]");
      var outMin = root.querySelector("[data-price-out-min]");
      var outMax = root.querySelector("[data-price-out-max]");
      if (!min || !max) return;

      var ceiling = parseFloat(root.dataset.rangeMax) || 0;
      var symbol = root.dataset.currencySymbol || "";

      var fmt = function (n) {
        return symbol + Math.round(n).toLocaleString();
      };

      var paint = function () {
        var lo = parseFloat(min.value);
        var hi = parseFloat(max.value);
        if (ceiling > 0) {
          fill.style.insetInlineStart = (lo / ceiling) * 100 + "%";
          fill.style.insetInlineEnd = 100 - (hi / ceiling) * 100 + "%";
        }
        if (outMin) outMin.textContent = fmt(lo);
        if (outMax) outMax.textContent = fmt(hi);
      };

      // Handles must not cross over each other.
      var clamp = function (moved) {
        var lo = parseFloat(min.value);
        var hi = parseFloat(max.value);
        if (lo > hi) {
          if (moved === min) min.value = hi;
          else max.value = lo;
        }
      };

      [min, max].forEach(function (input) {
        input.addEventListener("input", function () {
          clamp(input);
          paint();
        });
        // A handle parked at its bound is not a filter — dropping the name
        // keeps it out of the querystring so the URL stays clean.
        input.addEventListener("change", function () {
          min.disabled = parseFloat(min.value) <= 0;
          max.disabled = parseFloat(max.value) >= ceiling;
        });
      });

      paint();
    }

    function init() {
      document.querySelectorAll("[data-price-range]").forEach(setup);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  /* One horizontal scroll-snap track drives everything: thumbnails, swipe, the
     counter, hover-magnify, the lightbox, and variant switching. The public
     select(mediaId) method is the contract VariantSelects depends on. */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector("[data-pgallery-track]");
      this.slides = Array.from(this.querySelectorAll("[data-pgallery-slide]"));
      this.thumbs = Array.from(this.querySelectorAll("[data-pgallery-thumb]"));
      this.counter = this.querySelector("[data-pgallery-counter]");
      this.zoomBtns = Array.from(this.querySelectorAll("[data-pgallery-zoom]"));
      this.index = 0;
      this.reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.canMagnify = window.matchMedia("(hover: hover) and (min-width: 990px)");

      if (!this.track || this.slides.length === 0) return;

      this.thumbs.forEach((thumb) =>
        thumb.addEventListener("click", () => this.goTo(Number(thumb.dataset.index)))
      );
      this.zoomBtns.forEach((btn) =>
        btn.addEventListener("click", () => this.openLightbox(Number(btn.dataset.index)))
      );

      if ("IntersectionObserver" in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.setActive(Number(entry.target.dataset.index));
              }
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((s) => this.observer.observe(s));
      }

      this.initMagnify();
      this.initLightbox();
    }

    scrollTrackTo(track, index, behavior) {
      track.scrollTo({ left: index * track.clientWidth, behavior: behavior });
    }

    goTo(index, behavior) {
      if (index < 0 || index >= this.slides.length) return;
      const b = behavior || (this.reduce.matches ? "auto" : "smooth");
      this.scrollTrackTo(this.track, index, b);
      this.setActive(index);
    }

    setActive(index) {
      if (index === this.index && this._inited) return;
      this._inited = true;
      this.index = index;
      this.thumbs.forEach((t) => {
        const on = Number(t.dataset.index) === index;
        t.classList.toggle("is-active", on);
        if (on) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
      if (this.counter) {
        this.counter.textContent = this.counter.textContent.replace(/\d+/, String(index + 1));
      }
    }

    /* Public: variant switching calls this with the variant's featured media id. */
    select(mediaId) {
      const idx = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx >= 0) this.goTo(idx);
    }

    initMagnify() {
      if (!this.canMagnify.matches) return;
      this.zoomBtns.forEach((btn) => {
        if (!btn.querySelector("img")) return;
        btn.addEventListener("mousemove", (e) => {
          const r = btn.getBoundingClientRect();
          btn.style.setProperty("--magnify-x", ((e.clientX - r.left) / r.width) * 100 + "%");
          btn.style.setProperty("--magnify-y", ((e.clientY - r.top) / r.height) * 100 + "%");
          btn.classList.add("is-magnifying");
        });
        btn.addEventListener("mouseleave", () => btn.classList.remove("is-magnifying"));
      });
    }

    initLightbox() {
      this.lightbox = this.querySelector("[data-pgallery-lightbox]");
      if (!this.lightbox) return;
      this.lbTrack = this.lightbox.querySelector("[data-pgallery-lightbox-track]");
      this.lbSlides = Array.from(this.lightbox.querySelectorAll("[data-pgallery-lightbox-slide]"));
      this.lbCounter = this.lightbox.querySelector("[data-pgallery-lightbox-counter]");
      this.lbIndex = 0;

      const closeBtn = this.lightbox.querySelector("[data-pgallery-lightbox-close]");
      const prevBtn = this.lightbox.querySelector("[data-pgallery-lightbox-prev]");
      const nextBtn = this.lightbox.querySelector("[data-pgallery-lightbox-next]");
      if (closeBtn) closeBtn.addEventListener("click", () => this.lightbox.close());
      if (prevBtn) prevBtn.addEventListener("click", () => this.lbGo(this.lbIndex - 1));
      if (nextBtn) nextBtn.addEventListener("click", () => this.lbGo(this.lbIndex + 1));

      this.lightbox.addEventListener("keydown", (e) => {
        if (e.key === "ArrowRight") { e.preventDefault(); this.lbGo(this.lbIndex + 1); }
        else if (e.key === "ArrowLeft") { e.preventDefault(); this.lbGo(this.lbIndex - 1); }
      });

      // Tap on empty area (not the image or a control) closes.
      this.lightbox.addEventListener("click", (e) => {
        if (e.target.closest("button")) return;
        if (e.target.tagName === "IMG") return;
        this.lightbox.close();
      });

      const syncFromScroll = () => {
        if (!this.lbTrack.clientWidth) return;
        this.setLbIndex(Math.round(this.lbTrack.scrollLeft / this.lbTrack.clientWidth));
      };
      if ("onscrollend" in this.lbTrack) {
        this.lbTrack.addEventListener("scrollend", syncFromScroll);
      } else {
        this.lbTrack.addEventListener("scroll", () => {
          clearTimeout(this._lbTimer);
          this._lbTimer = setTimeout(syncFromScroll, 120);
        });
      }

      this.lightbox.addEventListener("close", () => {
        document.body.style.overflow = "";
        if (this._lastFocused && this._lastFocused.focus) this._lastFocused.focus();
        this.goTo(this.lbIndex, "auto");
      });
    }

    openLightbox(index) {
      if (!this.lightbox) return;
      this._lastFocused = document.activeElement;
      this.lbIndex = index;
      document.body.style.overflow = "hidden";
      this.lightbox.showModal();
      requestAnimationFrame(() => {
        this.scrollTrackTo(this.lbTrack, index, "auto");
        this.setLbIndex(index);
      });
      const closeBtn = this.lightbox.querySelector("[data-pgallery-lightbox-close]");
      if (closeBtn) closeBtn.focus();
    }

    lbGo(index) {
      if (index < 0 || index >= this.lbSlides.length) return;
      this.scrollTrackTo(this.lbTrack, index, this.reduce.matches ? "auto" : "smooth");
      this.setLbIndex(index);
    }

    setLbIndex(index) {
      this.lbIndex = index;
      if (this.lbCounter) {
        this.lbCounter.textContent = this.lbCounter.textContent.replace(/\d+/, String(index + 1));
      }
    }
  }
  if (!customElements.get("product-gallery")) customElements.define("product-gallery", ProductGallery);

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="number"]');
      this.querySelector("[data-qty-minus]").addEventListener("click", () => this.step(-1));
      this.querySelector("[data-qty-plus]").addEventListener("click", () => this.step(1));
    }
    step(dir) {
      const min = Number(this.input.min) || 1;
      const next = Math.max(min, (Number(this.input.value) || min) + dir);
      this.input.value = next;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
  if (!customElements.get("quantity-input")) customElements.define("quantity-input", QuantityInput);

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.url = this.dataset.url;
      this.gallery = document.querySelector("[data-gallery]");
      this.variants = this.parseVariants();
      this.addEventListener("change", () => this.onChange());
    }
    parseVariants() {
      const el = this.querySelector("[data-variant-json]");
      try { return JSON.parse(el.textContent); } catch (e) { return []; }
    }
    selectedValues() {
      return Array.from(this.querySelectorAll("input[data-option-value]:checked")).map((i) => i.value);
    }
    onChange() {
      const chosen = this.selectedValues();
      // Reflect selected value labels
      this.querySelectorAll(".product__option").forEach((fs, idx) => {
        const label = fs.querySelector("[data-option-selected]");
        if (label && chosen[idx] != null) label.textContent = chosen[idx];
      });
      const variant = this.variants.find((v) =>
        v.options.every((opt, i) => opt === chosen[i])
      );
      const section = document.querySelector('[data-section-id="' + this.section + '"]');
      const idInput = section && section.querySelector("[data-variant-id]");
      if (!variant) {
        if (idInput) idInput.value = "";
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(this.url, window.location.origin);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
      if (variant.featured_media && this.gallery) {
        this.gallery.select(String(variant.featured_media.id));
      }
      this.renderSection(variant.id, section);
    }
    renderSection(variantId, section) {
      fetch(this.url + "?variant=" + variantId + "&section_id=" + this.section)
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          ["#price-" + this.section, "[data-buy-buttons]"].forEach((sel) => {
            const next = doc.querySelector(sel);
            const cur = section.querySelector(sel);
            if (next && cur) cur.innerHTML = next.innerHTML;
          });
        })
        .catch(() => {});
    }
  }
  if (!customElements.get("variant-selects")) customElements.define("variant-selects", VariantSelects);

  /* Sticky mobile add-to-cart. The markup and styles already existed but had no
     behaviour at all: the bar was never unhidden and [data-sticky-add] had no
     handler, so the button was inert. Reveal the bar once the real buy button
     has scrolled out of view, and delegate the click to the product form via
     requestSubmit() so the cart drawer's submit interceptor still handles it. */
  (function initStickyAtc() {
    function setup() {
      var bar = document.querySelector("[data-sticky-atc]");
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!bar || !form) return;
      var anchor = form.querySelector("[data-buy-buttons]") || form;

      var addBtn = bar.querySelector("[data-sticky-add]");
      if (addBtn) {
        addBtn.addEventListener("click", function () {
          if (typeof form.requestSubmit === "function") form.requestSubmit();
          else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        });
      }

      var show = function (visible) {
        bar.hidden = !visible;
        bar.setAttribute("aria-hidden", visible ? "false" : "true");
      };
      show(false);

      if (!("IntersectionObserver" in window)) return;
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      ).observe(anchor);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setup);
    } else {
      setup();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.querySelectorAll('[data-auto-submit]').forEach((el) => {
    el.addEventListener('change', () => el.form && el.form.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nz-buy-box"] && !Shopify.designMode) return;
  try {
    
  /* ==========================================================================
     nz-buy-box controller
     Owns tier + colour selection for the whole page. Every other add-to-cart on
     the page (repeating CTAs, sticky bar) delegates here, so there is exactly
     one place that knows which variant is selected.
     ========================================================================== */
  (function () {
    'use strict';

    function init(root) {
      if (root.dataset.nzReady === 'true') return;
      root.dataset.nzReady = 'true';

      var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-nz-tier]'));
      var form = root.querySelector('form[action*="/cart/add"]');
      var input = root.querySelector('[data-nz-variant-input]');
      var atc = root.querySelector('[data-nz-atc]');
      var atcLabel = root.querySelector('[data-nz-atc-label]');
      var sticky = document.querySelector('[data-nz-sticky]');
      var devnote = root.querySelector('[data-nz-devnote]');
      var tierOption = root.dataset.tierOption || '';
      var colorOption = root.dataset.colorOption || '';

      // Tiers are optional. With none, this runs as a plain buy box: one price
      // off the variant, plus a colour selector.
      if (!form || !input || !atc) return;

      var variants = [];
      var raw = root.querySelector('[data-nz-variants]');
      if (raw) {
        try { variants = JSON.parse(raw.textContent) || []; } catch (e) { variants = []; }
      }

      var priceMap = {};
      var rawPrices = root.querySelector('[data-nz-prices]');
      if (rawPrices) {
        try { priceMap = JSON.parse(rawPrices.textContent) || {}; } catch (e) { priceMap = {}; }
      }

      var baseLabel = atcLabel ? atcLabel.textContent.trim() : 'Add to cart';
      var current = tiers.filter(function (t) {
        return t.getAttribute('aria-checked') === 'true';
      })[0] || tiers[0] || null;

      /* ---- variant resolution ------------------------------------------- */
      function optionValue(variant, name) {
        if (!name) return null;
        var opts = variant.options || [];
        for (var i = 0; i < opts.length; i++) {
          // options[] is positional; match against the product's option names
          // exposed on the variant when available.
          if (String(opts[i]).toLowerCase() === String(name).toLowerCase()) return opts[i];
        }
        return null;
      }

      function findVariant(tier) {
        if (tier) {
          var override = (tier.dataset.variantOverride || '').trim();
          if (override) return { id: override, available: true, synthetic: true };
        }

        var wantTier = tier ? (tier.dataset.optionValue || '').trim().toLowerCase() : '';
        var wantColor = selectedColor(tier);

        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = (v.options || []).map(function (o) {
            return String(o).trim().toLowerCase();
          });
          var tierOk = !wantTier || opts.indexOf(wantTier) !== -1;
          var colorOk = !wantColor || opts.indexOf(wantColor.toLowerCase()) !== -1;
          if (tierOk && colorOk) return v;
        }
        return null;
      }

      // With tiers, the colour lives inside the selected card. Without them,
      // there is one standalone selector on the section.
      function selectedColor(tier) {
        var scope = tier || root;
        var on = scope.querySelector('[data-nz-color][aria-pressed="true"]');
        return on ? on.dataset.nzColor : null;
      }

      /* ---- render -------------------------------------------------------- */
      function render() {
        tiers.forEach(function (t) {
          var on = t === current;
          t.setAttribute('aria-checked', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });

        var variant = findVariant(current);
        var sellable = !!(variant && (variant.synthetic || variant.available));

        // A tier card states its own price (it may cover a bundle that isn't a
        // single variant). Otherwise take the real formatted variant price.
        var price = '';
        var compare = '';
        if (current) {
          price = current.dataset.price || '';
          compare = current.dataset.compare || '';
        } else if (variant && priceMap[variant.id]) {
          price = priceMap[variant.id].p || '';
          compare = priceMap[variant.id].c || '';
        }

        document.querySelectorAll('[data-nz-price]').forEach(function (el) {
          el.textContent = price;
        });
        document.querySelectorAll('[data-nz-was]').forEach(function (el) {
          el.textContent = compare;
          el.hidden = !compare;
        });

        input.value = variant ? variant.id : '';
        atc.disabled = !sellable;

        if (atcLabel) {
          atcLabel.textContent = sellable
            ? baseLabel + ' · ' + price
            : (atc.dataset.unavailableLabel || 'Currently unavailable');
        }

        document.querySelectorAll('[data-nz-cta][data-nz-cta-action="add"]').forEach(function (b) {
          b.disabled = !sellable;
        });

        markUnavailableColors();
        reportWiring();
      }

      // Grey out any colour that has no sellable variant in its context — the
      // tier it sits in, or the product as a whole when there are no tiers.
      function markUnavailableColors() {
        var scopes = tiers.length ? tiers : [root];

        scopes.forEach(function (scope) {
          var wantTier = tiers.length ? (scope.dataset.optionValue || '').trim().toLowerCase() : '';

          scope.querySelectorAll('[data-nz-color]').forEach(function (btn) {
            var wantColor = String(btn.dataset.nzColor || '').toLowerCase();
            var found = null;

            for (var i = 0; i < variants.length; i++) {
              var opts = (variants[i].options || []).map(function (o) {
                return String(o).trim().toLowerCase();
              });
              if ((!wantTier || opts.indexOf(wantTier) !== -1) && opts.indexOf(wantColor) !== -1) {
                found = variants[i];
                break;
              }
            }
            btn.dataset.unavailable = found && found.available ? 'false' : 'true';
          });
        });
      }

      /* ---- theme-editor wiring report ------------------------------------ */
      function reportWiring() {
        if (!devnote) return;
        var missing = tiers
          .filter(function (t) { return !findVariant(t); })
          .map(function (t) {
            return t.dataset.optionValue || t.querySelector('.nz-buybox__tiername').textContent.trim();
          });

        if (!missing.length) {
          devnote.hidden = true;
          return;
        }
        devnote.hidden = false;
        devnote.innerHTML =
          '<b>' + missing.length + ' tier(s) cannot add to cart yet.</b>' +
          'No variant on this product matches: <strong>' + missing.join('</strong>, <strong>') +
          '</strong>. Create a <em>' + tierOption + '</em> option with these values (combined with <em>' +
          colorOption + '</em>), or paste a variant ID into the tier block. ' +
          'Add to cart stays disabled until then — deliberately, so a tier can never ' +
          'display one price and charge another.';
      }

      /* ---- interaction ---------------------------------------------------- */
      function select(tier) {
        current = tier;
        render();
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function (e) {
          if (e.target.closest('[data-nz-color]')) return;
          select(tier);
        });

        tier.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(tier);
            return;
          }
          var i = tiers.indexOf(tier);
          var next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tiers[(i + 1) % tiers.length];
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tiers[(i - 1 + tiers.length) % tiers.length];
          if (next) {
            e.preventDefault();
            select(next);
            next.focus();
          }
        });

        tier.querySelectorAll('[data-nz-color]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.stopPropagation();
            tier.querySelectorAll('[data-nz-color]').forEach(function (b) {
              b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
            });
            select(tier);
          });
        });
      });

      /* ---- standalone colour selector (no-tier mode) ---------------------- */
      if (!tiers.length) {
        root.querySelectorAll('[data-nz-colors] [data-nz-color]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            root.querySelectorAll('[data-nz-color]').forEach(function (b) {
              b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
            });
            render();
          });
        });
      }

      /* ---- delegated CTAs (repeating blocks + sticky bar) ----------------- */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-nz-cta]');
        if (!btn) return;
        e.preventDefault();

        if (btn.dataset.nzCtaAction === 'add') {
          if (atc.disabled) return;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(atc);
          } else {
            form.submit();
          }
          return;
        }

        root.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        if (current) current.focus({ preventScroll: true });
      });

      /* ---- sticky bar reveal ---------------------------------------------- */
      if (sticky && 'IntersectionObserver' in window) {
        var anchor = root.querySelector('.nz-buybox__buy') || root;
        sticky.hidden = false;
        new IntersectionObserver(
          function (entries) {
            sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
          },
          { rootMargin: '-100px 0px 0px 0px' }
        ).observe(anchor);
      }

      render();
    }

    function boot() {
      document.querySelectorAll('[data-nz-buybox]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Theme editor re-renders sections in place.
    document.addEventListener('shopify:section:load', boot);
  })();

  /* ==========================================================================
     nz-buy-box gallery controller
     Separate from the buy controller above on purpose: this owns nothing about
     price or variants, and a failure in one must not take out the other.

     The rail is the single source of truth for "which slide is showing". The
     thumbs, arrows and counter all read from it via IntersectionObserver rather
     than keeping their own index, so a native swipe, a thumb click and a
     keyboard arrow can never disagree.
     ========================================================================== */
  (function () {
    'use strict';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function initGallery(root) {
      var stage = root.querySelector('[data-nz-stage]');
      if (!stage || stage.dataset.nzGalleryReady === 'true') return;

      var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-nz-slide]'));
      if (slides.length < 2) return;
      stage.dataset.nzGalleryReady = 'true';

      var thumbWrap = root.querySelector('[data-nz-thumbs]');
      var thumbs = thumbWrap
        ? Array.prototype.slice.call(thumbWrap.querySelectorAll('[data-nz-thumb]'))
        : [];
      var prev = root.querySelector('[data-nz-gprev]');
      var next = root.querySelector('[data-nz-gnext]');
      var count = root.querySelector('[data-nz-count]');
      var countNow = root.querySelector('[data-nz-count-now]');
      var current = 0;

      // Revealed only now that they do something.
      [prev, next, count, thumbWrap].forEach(function (el) {
        if (el) el.hidden = false;
      });

      function scrollTo(i, smooth) {
        var target = slides[i];
        if (!target) return;
        var left =
          target.getBoundingClientRect().left -
          stage.getBoundingClientRect().left +
          stage.scrollLeft;
        var behavior = smooth && !(reduce && reduce.matches) ? 'smooth' : 'auto';
        if (stage.scrollTo) stage.scrollTo({ left: left, behavior: behavior });
        else stage.scrollLeft = left;
      }

      function paint(i) {
        current = i;
        thumbs.forEach(function (t, n) {
          t.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        if (countNow) countNow.textContent = String(i + 1);
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
      }

      paint(0);

      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          scrollTo(n, true);
        });
      });

      if (prev) {
        prev.addEventListener('click', function () {
          scrollTo(Math.max(0, current - 1), true);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollTo(Math.min(slides.length - 1, current + 1), true);
        });
      }

      // The rail reports which slide is showing; nothing else tracks it.
      //
      // A callback only carries the slides whose visibility *changed*, so
      // picking the best entry out of that batch compares a partial set and
      // can name a slide that is barely on screen. Keep every slide's last
      // known ratio and pick the maximum across all of them.
      if ('IntersectionObserver' in window) {
        var ratios = [];
        for (var r = 0; r < slides.length; r++) ratios.push(0);

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              var i = parseInt(e.target.getAttribute('data-nz-slide'), 10);
              if (!isNaN(i)) ratios[i] = e.intersectionRatio;
            });
            var bi = 0;
            var br = -1;
            for (var i = 0; i < ratios.length; i++) {
              if (ratios[i] > br) { br = ratios[i]; bi = i; }
            }
            if (br > 0 && bi !== current) paint(bi);
          },
          { root: stage, threshold: [0, 0.25, 0.5, 0.75, 1] }
        );
        slides.forEach(function (s) {
          io.observe(s);
        });
      }

      /* ---- lightbox --------------------------------------------------- */
      var dlg = root.querySelector('[data-nz-lightbox]');
      var zooms = Array.prototype.slice.call(root.querySelectorAll('[data-nz-zoom]'));
      if (!dlg || !zooms.length || typeof dlg.showModal !== 'function') return;

      var lbImg = dlg.querySelector('[data-nz-lbimg]');
      var lbPrev = dlg.querySelector('[data-nz-lbprev]');
      var lbNext = dlg.querySelector('[data-nz-lbnext]');
      var lbClose = dlg.querySelector('[data-nz-lbclose]');
      var lbAt = 0;

      function show(i) {
        var btn = zooms[i];
        if (!btn || !lbImg) return;
        lbAt = i;
        var w = btn.getAttribute('data-nz-zoom-w');
        var h = btn.getAttribute('data-nz-zoom-h');
        if (w && h) {
          lbImg.setAttribute('width', w);
          lbImg.setAttribute('height', h);
        }
        lbImg.src = btn.getAttribute('data-nz-zoom');
        lbImg.alt = btn.getAttribute('data-nz-zoom-alt') || '';
        if (lbPrev) lbPrev.disabled = i === 0;
        if (lbNext) lbNext.disabled = i === zooms.length - 1;
        // Keep the rail on the image being viewed, so closing lands you there.
        var si = parseInt(btn.closest('[data-nz-slide]').getAttribute('data-nz-slide'), 10);
        if (!isNaN(si)) scrollTo(si, false);
      }

      zooms.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          show(i);
          dlg.showModal();
        });
      });

      if (lbPrev) {
        lbPrev.addEventListener('click', function () {
          show(Math.max(0, lbAt - 1));
        });
      }
      if (lbNext) {
        lbNext.addEventListener('click', function () {
          show(Math.min(zooms.length - 1, lbAt + 1));
        });
      }
      if (lbClose) {
        lbClose.addEventListener('click', function () {
          dlg.close();
        });
      }

      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(Math.max(0, lbAt - 1)); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(Math.min(zooms.length - 1, lbAt + 1)); }
      });

      // Clicking the backdrop closes. The dialog fills the viewport, so the
      // test is "did the click miss the image and the buttons".
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) dlg.close();
      });

      // Free the decoded 2048px image once it is off screen.
      dlg.addEventListener('close', function () {
        if (lbImg) lbImg.removeAttribute('src');
      });
    }

    function bootGallery() {
      document.querySelectorAll('[data-nz-buybox]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootGallery);
    } else {
      bootGallery();
    }

    document.addEventListener('shopify:section:load', bootGallery);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll("[data-slide]"));
      if (this.slides.length <= 1) return;

      this.dots = Array.from(this.querySelectorAll("[data-dot]"));
      this.controls = this.querySelector("[data-controls]");
      this.prevBtn = this.querySelector("[data-prev]");
      this.nextBtn = this.querySelector("[data-next]");
      this.index = 0;

      this.classList.add("is-enhanced");
      if (this.controls) this.controls.hidden = false;

      this.prevBtn && this.prevBtn.addEventListener("click", () => this.go(this.index - 1));
      this.nextBtn && this.nextBtn.addEventListener("click", () => this.go(this.index + 1));
      this.dots.forEach((dot, i) => dot.addEventListener("click", () => this.go(i)));

      this.show(0);
    }

    go(n) {
      var total = this.slides.length;
      this.show(((n % total) + total) % total);
    }

    show(i) {
      this.index = i;
      this.slides.forEach(function (slide, j) {
        var active = j === i;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      this.dots.forEach(function (dot, j) {
        var active = j === i;
        dot.classList.toggle("is-active", active);
        if (active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }
  }

  if (!customElements.get("testimonial-slider")) {
    customElements.define("testimonial-slider", TestimonialSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
